<template>
  <div class="card">
    <div class="card-header bg-primary d-flex justify-content-between">
      <h5 class="mb-0 text-white">Interview Statistics</h5>
    </div>
    <div class="card-body">
      <div v-if="!showChart" class="alert alert-light text-center" role="alert">No Interview data</div>
      <div class="container-fluid" v-if="showChart">
        <div class="row justify-content-center row-cols-2">
          <div class="col-8">
            <BarChart v-if="showChart" :data="getChartData" :options="getChartOptions" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import formatter from "@/utils/formatter";
import BarChart from "@/components/charts/BarChart.vue";

export default {
  components: {
    BarChart,
  },
  props: {
    isLoading: Boolean,
    investigation: Object,
  },
  computed: {
    ...mapGetters("role", ["isVerensicsAdministrator", "isOrganizationAdministrator", "isInvestigationCreator", "isInvestigationViewer"]),
    formatter: () => formatter,
    showChart() {
      return this.investigation && this.investigation.statistics && this.investigation.statistics.total > 0;
    },
    getChartData() {
      if (!this.showChart) {
        return null;
      }

      const labels = ["Contact Me", "Declined", "Incomplete", "Never Started", "Admissions", "Observations", "Admissions & Observations", "No Findings"];
      const data = [
        this.investigation.statistics.contactMe || 0,
        this.investigation.statistics.declined || 0,
        this.investigation.statistics.incomplete || 0,
        this.investigation.statistics.neverStarted || 0,
        this.investigation.statistics.admissions || 0,
        this.investigation.statistics.observations || 0,
        this.investigation.statistics.admissionsAndObservations || 0,
        this.investigation.statistics.noFindings || 0,
      ];
      const backgroundColor = ["#00B894", "#CC6633", "#198ECB", "#666666", "#cc4c56", "#cccc4a", "#55688a", "#3aaa67"];

      return {
        datasets: [{ data, backgroundColor }],
        labels,
      };
    },
    getChartOptions() {
      var countTitle = `Total Count: ${this.investigation?.statistics?.total || 0}`;
      return {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: 0,
            bottom: 20,
            left: 0,
            right: 0,
          },
        },
        title: {
          display: true,
          fontSize: 24,
          padding: 20,
          text: ["Interview Results", countTitle],
        },
        animation: {
          duration: 0,
        },
        hover: {
          animationDuration: 0,
        },
        responsiveAnimationDuration: 0,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                fontSize: 14,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                fontSize: 14,
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            color: () => {
              return "black";
            },
            font: {
              size: 18,
            },
            formatter: function(value) {
              if (value === 0) return "";
              return `${value}`;
            },
            display: function() {
              return "auto";
            },
          },
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              var label = data.labels[tooltipItem.index] || "";
              if (label) {
                label += ": ";
              }
              label += data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + " Interviews";
              return label;
            },
          },
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";
</style>
